/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Select, Button, Row, Col, message, TreeSelect, InputNumber } from 'antd';
import { DmsTab, RegionCascader } from 'Components';
import { add, update, detail, getListSelect } from '../../service/channel';
import { sKeylist } from '../../service/dictionary/dataitem';
import { allChildren } from '../../service/zone';
import { peopleList as employee } from '../../service/people';
import { categoryTree } from '../../service/category';
import { nameValidator, checkTel, checkPhone } from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';
const FormItem = Form.Item;


class ChannelAdd extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      id: parseInt(this.props.params.channelId, 10),
      detail: {},
      options: [],//归属区域
      channels: [],//上级渠道
      employee: [],//所属业务员
      channel_rank: [],//渠道等级
      channel_type: [],//渠道类型
      product_categoryTree: [], //产品类型
    };
  }

  componentWillMount () { //准备数据
    const self = this;
    categoryTree({}).then(res => { //归属区域
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ product_categoryTree: res.data });
          }
        }, 200);
      }
    });
    allChildren({ id: 0 }).then(res => { //归属区域
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ options: res.data });
          }
        }, 200);
      }
    });
    getListSelect().then(res => { //上级渠道
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ channels: res.data });
          }
        }, 200);
      }
    });
    sKeylist({ sKey: 'channel_rank' }).then(res => { //渠道等级
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ channel_rank: res.data || [] })
        }
      }, 200);
    })
    sKeylist({ sKey: 'channel_type' }).then(res => { //渠道类型
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ channel_type: res.data || [] })
        }
      }, 200);
    })
    employee({ status: 1 }).then(res => { //所属业务员
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ employee: res.data || [] })
        }
      }, 200);
    })
  }

  componentDidMount () {
    this.mounted = true;
    const self = this;
    if (this.state.id > 0) {
      detail(self.state.id).then(res => {
        let data = res.data.dmsChannel;
        data.areaIdList = data.areaList.map(x => x.areaId.toString());
        data.productTypeIdList = data.productList.map(x => x.productTypeId.toString());
        self.setState({
          ...this.state,
          detail: data
        })
      })
    }
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    const self = this;
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      const result = {
        ...data,
        ...data.adminDiv.value,
        channelType: data.channelType ? parseInt(data.channelType, 10) : null,
        rank: data.rank ? parseInt(data.rank, 10) : null,
        parentId: data.parentId ? parseInt(data.parentId, 10) : null,
        areaId: data.areaId ? parseInt(data.areaId, 10) : null,
        employeeId: data.employeeId ? parseInt(data.employeeId, 10) : null,
        employeeNum: data.employeeNum ? parseInt(data.employeeNum, 10) : null,
        areaIdList: data.areaIdList ? data.areaIdList.map(x => parseInt(x, 10)) : null,
        productTypeIdList: data.productTypeIdList ? data.productTypeIdList.map(x => parseInt(x, 10)) : null,
      }
      delete result.adminDiv; //删除冗余数据

      console.log(`你正在提交数据：${JSON.stringify(data)}`);

      showSpin();
      if (self.state.id) {
        delete result.contacts;
        delete result.contactsMobile;
        update({ ...result, id: self.state.id }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      } else {
        add(result).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      }
    })
  }

  setAdminDiv (val) {
    this.setState({
      province: val[0] || '',
      city: val[1] || '',
      county: val[2] || '',
    });
  }

  render () {
    const { detail, id, employee, channels, channel_rank, channel_type, options, product_categoryTree } = this.state;
    const { getFieldDecorator } = this.props.form;
    return <div className="dms-body">
      <DmsTab options={[`${id > 0 ? '编辑渠道' : '新建渠道'}`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="公司名称：" hasFeedback>
                {getFieldDecorator('name', {
                  initialValue: detail.name || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入公司名称'
                    },
                    {
                      validator: nameValidator
                    }
                  ],
                })(<Input placeholder="请输入公司名称"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="渠道编码：" hasFeedback>
                {getFieldDecorator('code', {
                  initialValue: detail.code || '',
                  rules: [
                    {
                      //required: id > 0,
                      required: false,
                      message: '请输入渠道编码'
                    },
                  ],/*<Input disabled={id <= 0} placeholder={id <= 0 ? "渠道编码由后端生成" : "请输入渠道编码"}/>*/
                })(<Input disabled={true} placeholder={"渠道编码由后端生成"}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="简称：" hasFeedback>
                {getFieldDecorator('shortName', {
                  initialValue: detail.shortName || '',
                  rules: [
                    {
                      required: false,
                    },
                    {
                      validator: nameValidator
                    }
                  ],
                })(<Input placeholder="请输入简称"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="上级渠道：" hasFeedback>
                {getFieldDecorator('parentId', detail && detail.parentId ? {
                  initialValue: detail.parentId + '',
                } : null)(<Select
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="请选择上级渠道"
                >
                  {
                    channels.map((item, index) => {
                      return <Select.Option key={index + ''} value={item.id + ''}>{item.name}</Select.Option>
                    })
                  }
                </Select>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="rankBox">
                <FormItem label="等级：" hasFeedback>
                  {getFieldDecorator('rank', detail && detail.rank ? {
                    initialValue: detail.rank + '',
                  } : null)(
                    <Select
                      allowClear
                      style={{ width: '100%' }}
                      placeholder="请选择等级"
                      getPopupContainer={() => document.getElementById('rankBox')}
                    >
                      {
                        channel_rank.map((item, index) => {
                          return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                        })
                      }
                    </Select>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="channelTypeBox">
                <FormItem label="类型：" hasFeedback>
                  {getFieldDecorator('channelType', detail && detail.channelType ? {
                    initialValue: detail.channelType + '',
                    rules: [
                      {
                        required: true,
                        message: '请选择类型'
                      },
                    ],
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择类型'
                      },
                    ],
                  })(<Select
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="请选择类型"
                    getPopupContainer={() => document.getElementById('channelTypeBox')}
                  >
                    {
                      channel_type.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          {
            id === 0 && <Row gutter={16}>
              <Col className="gutter-row" span={12}>
                <FormItem label="联系人：" hasFeedback>
                  {getFieldDecorator('contacts', {
                    initialValue: detail.contacts || '',
                    rules: [
                      {
                        required: true,
                        message: '请输入联系人'
                      },
                      {
                        validator: nameValidator
                      }
                    ],
                  })(<Input placeholder="请输入联系人"/>)}
                </FormItem>
              </Col>
              <Col className="gutter-row" span={12}>
                <FormItem label="联系人手机：" hasFeedback>
                  {getFieldDecorator('contactsMobile', {
                    initialValue: detail.contactsMobile || '',
                    rules: [
                      {
                        required: true,
                        message: '请输入联系人手机'
                      },
                      {
                        validator: checkPhone
                      }
                    ],
                  })(<Input placeholder="请输入联系人手机"/>)}
                </FormItem>
              </Col>
            </Row>
          }
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <div id="adminDivBox">
                <FormItem label="公司地址：" hasFeedback>
                  {getFieldDecorator('adminDiv', id > 0 ? {
                    initialValue: {
                      province: detail.province ? parseInt(detail.province, 10) : '',
                      city: detail.city ? parseInt(detail.city, 10) : '',
                      county: detail.county ? parseInt(detail.county, 10) : '',
                    },
                    rules: [
                      {
                        required: true,
                        message: '请选择公司地址'
                      },
                    ],
                    getValueFromEvent: (e) => {

                      return e
                    }
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择公司地址'
                      },
                    ],
                    getValueFromEvent: (e) => {

                      return e
                    }
                  })(<RegionCascader containerId="adminDivBox" placeholder="请选择公司地址" style={{ width: '100%' }}/>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label={null} hasFeedback>
                {getFieldDecorator('address', {
                  initialValue: detail.address || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入详细地址'
                    },
                  ],
                })(<Input placeholder="请输入详细地址" style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="areaIdBox">
                <FormItem label="归属区域：" hasFeedback>
                  {getFieldDecorator('areaId', detail && detail.areaId ? {
                    initialValue: detail.areaId.toString(),
                    rules: [
                      {
                        required: true,
                        message: '请选择归属区域'
                      },
                    ],
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择归属区域'
                      },
                    ],
                  })(<TreeSelect
                    size="large"
                    treeDefaultExpandAll
                    placeholder="请选择归属区域"
                    dropdownStyle={{maxHeight: '240px', overflow:'auto'}}
                    treeData={options}
                    getPopupContainer={() => document.getElementById('areaIdBox')}
                  />)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="employeeIdBox">
                <FormItem label="所属业务员：" hasFeedback>
                  {getFieldDecorator('employeeId', detail && detail.employeeId ? {
                    initialValue: detail.employeeId + '',
                    rules: [
                      {
                        required: false,
                        message: '请选择所属业务员'
                      },
                    ],
                  } : null)(<Select
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="请选择所属业务员"
                    optionFilterProp="desc"
                    dropdownStyle={{maxHeight: '240px', overflow:'auto'}}
                    getPopupContainer={() => document.getElementById('employeeIdBox')}
                  >
                    {
                      employee.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.id + ''}
                                              desc={item.name}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <div id="productTypeIdListBox">
                <FormItem label="销售产品：" hasFeedback>
                  {getFieldDecorator('productTypeIdList', detail && detail.productTypeIdList && detail.productTypeIdList.length ? {
                    initialValue: detail.productTypeIdList.map(x => x.toString()),
                    rules: [
                      {
                        required: true,
                        message: '请选择销售产品'
                      },
                    ],
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择销售产品'
                      },
                    ],
                  })(<TreeSelect
                    size="large"
                    multiple={true}
                    treeCheckable={true}
                    treeDefaultExpandAll
                    showCheckedStrategy={TreeSelect.SHOW_ALL}
                    treeData={product_categoryTree}
                    placeholder="请选择销售产品"
                    dropdownStyle={{maxHeight: '240px', overflow:'auto'}}
                    getPopupContainer={() => document.getElementById('productTypeIdListBox')}
                  />)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <div id="areaIdListBox">
                <FormItem label="销售地区：" hasFeedback>
                  {getFieldDecorator('areaIdList', detail.areaIdList ? {
                    initialValue: detail.areaIdList.map(x => x.toString()),
                    rules: [
                      {
                        required: true,
                        message: '请选择销售地区'
                      },
                    ],
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择销售地区'
                      },
                    ],
                  })(<TreeSelect
                    size="large"
                    multiple={true}
                    treeCheckable={true}
                    treeDefaultExpandAll
                    treeData={options}
                    dropdownStyle={{maxHeight: '240px', overflow:'auto'}}
                    placeholder="请选择销售地区"
                    getPopupContainer={() => document.getElementById('areaIdListBox')}
                  />)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="公司电话：" hasFeedback>
                {getFieldDecorator('compnyPhone', {
                  initialValue: detail.compnyPhone || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入公司电话'
                    },
                    {
                      validator: checkTel
                    }
                  ],
                })(<Input placeholder="请输入公司电话"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="公司传真：" hasFeedback>
                {getFieldDecorator('companyFax', {
                  initialValue: detail.companyFax || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入公司传真'
                    },
                  ],
                })(<Input placeholder="请输入公司传真"/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="员工总数：" hasFeedback>
                {getFieldDecorator('employeeNum', {
                  initialValue: detail.employeeNum || 0,
                  rules: [
                    {
                      required: false,
                      message: '请输入员工总数'
                    },
                  ],
                })(<InputNumber min={0} placeholder="请输入员工总数" style={{width:'100%'}}/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="公司网址：" hasFeedback>
                {getFieldDecorator('companyWebsite', {
                  initialValue: detail.companyWebsite || '',
                  rules: [
                    {
                      type: "url",
                      message: '公司网址格式不正确'
                    }
                  ],
                })(<Input placeholder="请输入公司网址"/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="CEO：" hasFeedback>
                {getFieldDecorator('companyCeo', {
                  initialValue: detail.companyCeo || ''
                })(<Input placeholder="请输入CEO名称"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="年度收入(万元)：" hasFeedback>
                {getFieldDecorator('companyIncome', {
                  initialValue: detail.companyIncome || 0
                })(<InputNumber min={0} placeholder="请输入年度收入" style={{width: '100%'}}/>)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
}
export default Form.create()(ChannelAdd)


// WEBPACK FOOTER //
// ./src/routes/channel/add.js